var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 249,
    viewBox: "0 0 248 249",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: 124.5,
    rx: 124,
    ry: 124.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.857 75H81.1205C77.192 75 74 78.2366 74 82.2098V167.79C74 171.763 77.192 175 81.1205 175H166.857C170.786 175 174 171.763 174 167.79V82.2098C174 78.2366 170.786 75 166.857 75ZM104.223 160.714H89.4018V112.991H104.246V160.714H104.223ZM96.8125 106.473C92.058 106.473 88.2188 102.612 88.2188 97.8795C88.2188 93.1473 92.058 89.2857 96.8125 89.2857C101.545 89.2857 105.406 93.1473 105.406 97.8795C105.406 102.634 101.567 106.473 96.8125 106.473V106.473ZM159.781 160.714H144.96V137.5C144.96 131.964 144.848 124.844 137.259 124.844C129.536 124.844 128.353 130.871 128.353 137.098V160.714H113.531V112.991H127.75V119.509H127.951C129.937 115.759 134.781 111.808 141.991 111.808C156.991 111.808 159.781 121.696 159.781 134.554V160.714V160.714Z",
    fill: "#8091B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.aa34672601a65196ef1c8d79fe010d07.svg";
export { ForwardRef as ReactComponent };